import React,{useEffect,useState,useCallback} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'

import { BASE_URL } from '../Config/Base';
import {Oval } from 'react-loader-spinner'
import {CircleLoader} from 'react-spinners';



const pageSize = 5;

const TCaddusermain = () => {

   // GET request using fetch()

     let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
    const [allusers,setAllusers]= useState([])
    const[details, setDetails] =useState([])

    const[pop,setpop] = useState(false);
    const[role, setRole] =useState([])

  const [paginatedPosts, setpaginatedPosts] = useState();
  //const [currentPage, setcurrentPage] = useState(1);

  const[Active,setActive]=useState('0')   

      const[InActive,setInActive]=useState('1') 

      const handleactive=()=>{
        setActive(1);
      }
      
      const handleInactive=()=>{
        setInActive(0);
      }
     
      useEffect(() => {
       
        setpop(true);
        //document.getElementById('Tc-Pag').style.display = "none"
        setTimeout(() => {
          setpop(false);
          getTcAllUsers()
          GetTcUserRole()
          //document.getElementById('Tc-Pag').style.display = "flex"
        }, 2000);

        
      }, [])
 
  function getTcAllUsers(){
    fetch('https://localhost:44312/Api/Tc/GetTcusers', {
     
    method:'GET',
  
      headers : {
  
        "Content-type": "application/json",
  
        "Accept": "application/json",
  
        "Authorization": bearer,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },
  


}).then(response => response.json())
.then(data => {
console.log("Data",data)
  setAllusers(data)
  setpaginatedPosts(_(data).slice(0).take(pageSize).value());
  localStorage.setItem("TCUserData", JSON.stringify(data));
});

console.log("check",allusers)
  }




// const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;

// const pages = _.range(1, pageCount+1)

// const pagination =(pageNo)=>{
// setcurrentPage(pageNo);
// const startIndex = (pageNo - 1) * pageSize;
// const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
// setpaginatedPosts(paginatedPost)
// }


function fetchTCdata()
 {

  let data = {
    username:document.getElementById('username').value,
email:document.getElementById('email').value,
password:document.getElementById('password').value,
    role:document.getElementById('roleid').value,
    ventureid:'01',
    active:1,
    deleteStatus:0,
    assignStatus:1,
    roleid:'02',
    ventureName:'Thats Cool'
    
  }
 
  
  axios({

      method:"POST",
     // url:`${BASE_URL}/Authenticate/Register`,
      url:"https://localhost:44312/Api/Authenticate/Register",
      data,
      headers: {
        "Content-Type" : "application/json"
      }

  })
  .then((response) =>{
    console.log(response.data);
    console.log(response.data.status)
   
    if(response.data.status === "Success"){
     
       
            document.getElementById('success-notify').style.display = "block"
             setTimeout(()=>{
               document.getElementById('success-notify').style.display = "none"
             },1000)
     
          document.getElementById("tcaddForm").style.display = "none";
          getTcAllUsers()
     
       
        
     }
     else if(response.data.message === "Username Already Exist"){
     //alert("Username Already Exist")
    
      document.getElementById('nameerror-notify').style.display = "block"
       setTimeout(()=>{
         document.getElementById('nameerror-notify').style.display = "none"
       },1000)
    
    }

   
    else if(response.data.message === "Email Already Exist"){
      //alert("Email Already Exist")
      document.getElementById('emailerror-notify').style.display = "block"
      setTimeout(()=>{
        document.getElementById('emailerror-notify').style.display = "none"
      },1000)
    }
 
   
  })
.catch(error => {
console.log(error);
alert("User creation failed") 

})



}


/*----function with validation----*/


function handleSubmit(event){

event.preventDefault()     


  var name = document.getElementById("username").value;
  var mail = document.getElementById("email").value;
  const email1 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var password = document.getElementById("password").value;
  const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 
  var role = document.getElementById("roleid").value;



  if(!name){
        
    document.getElementById("nameErr").innerHTML="Username Required";
 
  }
  else if(name.length<3)
  {
    document.getElementById("nameErr").innerHTML=" ";
    document.getElementById("nameErrA").innerHTML="Enter Atleast 3 Characters ";
    
  }
  else{
    document.getElementById("nameErr").innerHTML=" ";
    document.getElementById("nameErrA").innerHTML=" ";
   
  }

  if(!mail){

    document.getElementById("mailErr").innerHTML="Mail Required ";    
  }
  else if (email1.test(document.getElementById("email").value)===false){

    document.getElementById("mailErrA").innerHTML="Not Valid Email";
    document.getElementById("mailErr").innerHTML=" ";  
 }
  else{

    document.getElementById("mailErr").innerHTML="  ";  
    document.getElementById("mailErrA").innerHTML="  ";  

  }
  if(!password){
  
    document.getElementById("passErr").innerHTML="Password Required ";    

  }
  else if (password1.test(document.getElementById("password").value)===false){

    document.getElementById("passErrA").innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
    document.getElementById("passErr").innerHTML=" ";  
 }
  else{

    document.getElementById("passErr").innerHTML="  ";  
    document.getElementById("passErrA").innerHTML="  ";  

  }

  if(!role){

    document.getElementById("roleErr").innerHTML="Role Required ";
  }
  else{

    document.getElementById("roleErr").innerHTML=" ";

   
  }
  if((name.length>3) && (email1.test(document.getElementById("email").value)===true) && (password1.test(document.getElementById("password").value)===true) && role  ){

    fetchTCdata();

  }
}


function handlechange(event){
  event.preventDefault()
 

  var name = document.getElementById("username").value;

  var mail = document.getElementById("email").value;

  const email1 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  var password = document.getElementById("password").value;
  
  const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 
 
  var role = document.getElementById("roleid").value;

  if(!name){
        
    document.getElementById("nameErr").innerHTML="Username Required";
    document.getElementById("nameErrA").innerHTML=" ";
   
  }
  else if(name.length<3)
  {
    document.getElementById("nameErr").innerHTML=" ";
    document.getElementById("nameErrA").innerHTML="Enter Atleast 3 Characters ";
    
  }
  else{
    document.getElementById("nameErr").innerHTML=" ";
    document.getElementById("nameErrA").innerHTML=" ";
  }

  if(!mail){

    document.getElementById("mailErr").innerHTML="Mail Required ";
    document.getElementById("mailErrA").innerHTML="  ";      
  }
  else if (email1.test(document.getElementById("email").value)===false){

    document.getElementById("mailErrA").innerHTML="Not Valid Email";
    document.getElementById("mailErr").innerHTML= "";  
 }
  else{

    document.getElementById("mailErr").innerHTML="  ";  
    document.getElementById("mailErrA").innerHTML="  ";  

  }
  if(!password){
  
    document.getElementById("passErr").innerHTML="Password Required "; 
    document.getElementById("passErrA").innerHTML="  ";     

  }
  else if (password1.test(document.getElementById("password").value)===false){

    document.getElementById("passErrA").innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
    document.getElementById("passErr").innerHTML=" ";  
 }
  else{

    document.getElementById("passErr").innerHTML="  ";  
    document.getElementById("passErrA").innerHTML="  ";  

  }
  
  if(!role){

    document.getElementById("roleErr").innerHTML="Role Required ";
  }
  else{

    document.getElementById("roleErr").innerHTML=" ";
  
  }
}

function Tcadduserhide(){

  var x = document.getElementById("password");

  var eye = document.getElementById("eye-adduser");

  if(x.type === "password"){
 x.type = "text";
    eye.classList.remove("fa-eye-slash")
    eye.classList.add("fa-eye")
   
 }
  else{
    x.type = "password";
    eye.classList.remove("fa-eye")
    eye.classList.add("fa-eye-slash")

  }
 }

 /*----Function open form----*/

 function openForm()

 {
 document.getElementById("tcaddForm").style.display = "block";

  }

/*----Function close form----*/
function closeForm()

  {

   // window.location.reload();

     document.getElementById("tcaddForm").style.display = "none";
document.getElementById("adduserfrom").reset();

document.getElementById("nameErr").innerHTML=" ";
document.getElementById("nameErrA").innerHTML=" ";

document.getElementById("mailErr").innerHTML="  ";  
document.getElementById("mailErrA").innerHTML="  ";  

document.getElementById("passErr").innerHTML="  ";  
document.getElementById("passErrA").innerHTML="  ";  

document.getElementById("roleErr").innerHTML="";

   }

   
/*----delete btn func----*/

function DeleteStatus(Id,userName){

  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
   const body ={
    id: Id
  }
   console.log(body)
    axios({
  
    method:"POST",
    url: `${BASE_URL}/Tc/DeleteStatus`,
   //url:"https://localhost:44312/Api/Tc/DeleteStatus",
   data:body,
   headers: {
   "Content-Type" : "application/json",
   'Authorization':bearer
   }

   
  
    })
    .then((response) =>{
    console.log(response.data);
    
    if(response.data.status === "Success"){
      if(response.data.status=='Success'){
        document.getElementById('del-notify').style.display = "block"
         setTimeout(()=>{
           document.getElementById('del-notify').style.display = "none"
         },1000)
      }
    
     document.getElementById("modalDeleteForm").style.display = "none";
     getTcAllUsers()
    }

    })
 
    } 
    function ConfirmDelete(Id){

      document.getElementById("modalDeleteForm").style.display = "block";
      getDetails(Id)
     
    }
     
   
    function getDetails(Id){
   
      let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
      
     
     const body ={
      
      id:Id
    
     }
     console.log(body);
    
    
      axios({          
         method: "POST", 
         url: `${BASE_URL}/Tc/GetTcPrUser`,      
         //url: "https://localhost:44312/Api/Tc/GetTcPrUser",
         data:body,
         headers: {             
           'Content-Type': 'application/json' , 
           'Authorization':bearer     
         }
       
       })
       .then((response) =>{
        console.log(response.data);
        setDetails(response.data)
        
        localStorage.setItem("EditData", JSON.stringify(response.data));
         }) 
    
    } 

 

    function TcEditUser(Id){

      getDetails(Id)

        setTimeout(()=>{
          window.location.href="/?#/TcEditPop"
        },1000)

    
    }

       function UpdateTcUser(Id,Activestate){

        if(Activestate==0){
          var Action=Active
        }
        
        else {
          var Action=InActive
        }

        let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
      var username = document.getElementById('Name').value;

       
            const body ={
              
              name:username,
              normalizedUserName:username,
              id:Id,
              active:Action
             
            }
          console.log(body)
            
              axios({
            
                method: "POST",
                   url: `${BASE_URL}/Tc/UpdateTcUser`,
                //url: "https://localhost:44312/Api/Tc/UpdateTcUser",
                data:body,
                headers: {
                  
                  'Content-Type': 'application/json' ,      
                  'Authorization':bearer
                }
              
              })
             
              .then((response) =>{
                console.log(response.data);
              
               EditcloseForm() 
            getTcAllUsers()        
              
                 })
                
                 .catch(error => {
                console.log(error);
                 alert("failed !")       
                 })
               
          
                }  

/*----Function close form----*/

function EditcloseForm()

  {

     document.getElementById("userEditForm").style.display = "none";
      document.getElementById("editform").reset();
   
   }
   
   function closedelForm()
   {
      document.getElementById("modalDeleteForm").style.display = "none";
    
    }

   
function Cancel() {
   document.getElementById("modalDeleteForm").style.display = "none";      

      }

      function GetTcUserRole(){

        fetch('https://localhost:44312/Api/Tc/GetTcUserRole', {
          method:'GET',
          headers : {
    
            "Content-type": "application/json",
    
            "Accept": "application/json",
      
      
            "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
          },
    
    
        })
         .then(response => response.json())
        .then(data => {
          console.log(data)   
          setRole(data);
          localStorage.setItem("RoleData", JSON.stringify(data));
        
        });
      }
    
/*----Pagination----*/

      const LEFT_PAGE = "LEFT";
      const RIGHT_PAGE = "RIGHT";
      const range = (from, to, step = 1) => {
        let i = from;
        const range = [];
      
        while (i <= to) {
          range.push(i);
          i += step;
        }
      
        return range;
      };
      
      const [currentPage, setCurrentPage] = useState(1);
      
      let data = localStorage.getItem("TCUserData")
      let transdata =  JSON.parse(data);
    
      let NUM_OF_RECORDS = transdata.length;
      let LIMIT = 5;
      
      const onPageChanged = useCallback(
      
        (event, page) => {
          event.preventDefault();
          setCurrentPage(page);
        },
        [setCurrentPage]
        
      );
      
      
      const currentData = transdata.slice(
        (currentPage - 1) * LIMIT,
        (currentPage - 1) * LIMIT + LIMIT
      );
      
      const Paginations = (props) => {
        const {
          totalRecords,
          pageLimit,
          pageNeighbours,
          onPageChanged,
          currentPage
        } = props;
        const [totalPages, setTotalPages] = useState(0);
        useEffect(() => {
          setTotalPages(Math.ceil(totalRecords / pageLimit));
        }, [setTotalPages]);
      
        const fetchPageNumbers = () => {
          const totalNumbers = pageNeighbours * 2 + 3;
         
          const totalBlocks = totalNumbers + 2;
        
      
          if (totalPages > totalBlocks) {
            const startPage = Math.max(2, currentPage - pageNeighbours);
            const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
      
            let pages = range(startPage, endPage);
      
            const hasLeftSpill = startPage > 2;
            const hasRightSpill = totalPages - endPage > 1;
            const spillOffset = totalNumbers - (pages.length + 1);
      
            switch (true) {
              case hasLeftSpill && !hasRightSpill: {
                const extraPages = range(startPage - spillOffset, startPage - 1);
                pages = [LEFT_PAGE, ...extraPages, ...pages];
                break;
              }
              case hasLeftSpill && hasRightSpill:
              default: {
                pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
                break;
              }
            }
            return [1, ...pages, totalPages];
          }
          return range(1, totalPages);
        };
      
      
        const pages = fetchPageNumbers() || [];
        return (
          <nav aria-label="Countries Pagination" >
            <ul className="pagination">
              {pages.map((page, index) => {
                if (page === LEFT_PAGE)
                  return (
                    <li key={index} className="page-item">
                      <a
                        href="/"
                        className="page-link"
                        aria-label="Previous"
                        onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                      >
                        <span aria-hidden="true">&laquo;</span>
                      </a>
                    </li>
                  );
      
                if (page === RIGHT_PAGE)
                  return (
                    <li key={index} className="page-item">
                      <a
                        className="page-link"
                        href="/"
                        aria-label="Next"
                        onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 3)}
                      >
                        <span aria-hidden="true">&raquo;</span>
                      </a>
                    </li>
                  );
      
                return (
                  <li
                    key={index}
                    className={`Tc-page-item${currentPage === page ? " active" : ""}`}
                  >
                    <a
                      className="page-link"
                      href="/"
                      onClick={(e) => onPageChanged(e, page)}
                    >
                      {page}
                    </a>
                  </li>
                );
              })}
            </ul>
          </nav>
        );
      };
      
/*----Main Container----*/

  return (
      
    <>
    
    <div className='TC-addmain'>

  
    <div className="TC-addgrid-layout">
  <div className="TC-addmain-top">
  <div className='TC-addmain-back'>
    <Link to='/Thats Cool'><i className="fa-sharp fa-solid fa-backward"></i></Link>
    </div> 
    <span> TC Users</span>
    </div>
    </div>

    <div className='TC-addmain-add'>
    
    <Link to="/TcAddUserRole"><button className='Tc-add-userRole'><i className="fas fa-users"></i>&nbsp;&nbsp;Add UserRole</button></Link> 
    <button className='Tc-add-user' onClick={openForm}><i className="fa-solid fa-user-plus"></i>&nbsp;&nbsp;Add User</button> 
    </div>
    <div className='TCpopfade' id="tcaddForm">
  <div className="modal-dialog" role="document">
    <div className="modal-content" id="modal-Popup">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD USER</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
     
      <form id='adduserfrom'>
              <div className="modal-body mx-3">
                  <div className="md-form mb-3">
         
                     <input type="text" className="form-control validate"  placeholder='Username'   onKeyUp={handlechange} id="username"/>
                     <span id="nameErr" className='Tcadduser-error'></span>
                     <span id="nameErrA" className='Tcadduser-error'></span>

                  </div>

                  <div className="md-form mb-3">
          
                      <input type="email"  className="form-control validate" placeholder='Email'  onKeyUp={handlechange} id="email" />
                      <span id="mailErr" className='Tcadduser-error'></span>
                      <span id="mailErrA" className='Tcadduser-error'></span>
                  </div>

                  <div className="md-form mb-3">
                  <div className='TCadduser-eyeicon'><i class="fa fa-eye-slash" aria-hidden="true" onClick={Tcadduserhide} id="eye-adduser"></i></div>      
                      <input type="password" className="form-control validate" placeholder='Password'     onKeyUp={handlechange} id="password"/>
                      <span id="passErr" className='Tcadduser-error'></span>
                      <span id="passErrA" className='Tcadduser-error'></span>
                  </div>
                  <div className="md-form mb-3">
                          <select  name="role"  className="form-select"  onInputCapture={handlechange} id="roleid" >
                          <option value="">Role</option>
                          {role.map((e)=>{
      return<option value={e.role}>{e.role}</option>
    })}
                          </select> 
                          <span id="roleErr" className='Tcadduser-error'></span>  
                        
                        </div>
 
                </div>
      
                  <div className="modal-footer d-flex justify-content-center">
                        <button  className='TC-adduser-button' onClick={handleSubmit} >Submit</button>
                  </div>

             </form>

    </div>
  </div>
</div>

<div className='TCpopfade' id='del-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>User&nbsp;<span style={{color:"red"}}>Deleted</span></p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
        
          </section> 
            
    </div>
  </div>
</div>

 <div className='TCtable'>

  <div class="TC-table_responsive">
  
  {
  !paginatedPosts ? (<span style={{display:'flex',justifyContent:'center'}}>No Data Found</span>):(
  <table  className='TC-tblhead' id='TcUserTbl'> 
    <thead>
   <tr>
<th>Username</th>
<th>Email</th>
<th>Action</th>
</tr>
</thead>
<tbody>

   {/* mapping to adduser */}

   {currentData.map((e,index) => {
      return<tr key={index}>
           <td >{e.userName}</td>
           <td >{e.email}</td>
                 <td>
               
<i className="fa-regular fa-pen-to-square" id="Tcediticon" onClick={()=>TcEditUser(e.id)}></i> &nbsp; &nbsp; 
<i className="fa-solid fa-trash" id="Tcdelicon" onClick={()=>ConfirmDelete(e.id,e.userName)}></i>   
              </td>
       
      </tr>
      })}
    
</tbody>

</table>
)}

<br></br><br></br>
{
  !paginatedPosts ? (""):(
 <nav id='Tc-Pag'>
  {transdata.length<=5 ? null:  <ul className='Tc-pagination'> 

    <Paginations
            totalRecords={NUM_OF_RECORDS}
            pageLimit={LIMIT}
            pageNeighbours={3}
            onPageChanged={onPageChanged}
            currentPage={currentPage}
          />
    
</ul>}
  </nav> 
  )}
        
</div>

    </div>

    <div className='TCpopfade' id='success-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    
    <section class="notif notif-notice" id="successnotif">
             
             <p>User Register</p>
             <h6 class="notif-title">Successfully !&nbsp;<i class="fa-solid fa-thumbs-up" style={{fontSize:'25px'}}></i></h6>
          </section> 
            
          
    </div>
  </div>
</div>

<div className='TCpopfade' id='nameerror-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    <section class="notif notif-alert" id="errnotify">
      <p> </p>
      <h6 class="notif-title"> Username Already Exist</h6>
   </section>
    </div>
  </div>
</div>

<div className='TCpopfade' id='emailerror-notify'>
  <div className="modal-dialog" role="document">
    <div className="notification-div">
    <section class="notif notif-alert" id="errnotify">
      <p> </p>
      <h6 class="notif-title">Email Already Exist</h6> 
   </section>
    </div>
  </div>
</div>
    <div className='TCpopfade' id="userEditForm">
   
  <div className="modal-dialog" role="document">
    <div className="modal-contentt">
  
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">Edit Form</h4>
        <button type="button" className="close" onClick={EditcloseForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
     
      <form id='editform'>    
      {details.map((e)=>
{
return<div>
 
   <div className="modal-body mx-3">
                  <div className="md-form mb-3">
                  <input type="username" id='Name' defaultValue={e.userName} />
             
                  </div>
    
 <div className="md-form mb-3">
 <input type="email" placeholder='text' value={e.email}/>

                  </div>
                  <div className="md-form mb-3">
                  <input type="username" id='PSW' defaultValue={e.passwordHash} />
             <button id='generatepswbtn'>Generate</button>
                  </div>
                </div>
                <div className="md-form mb-3">
                  <div className=' d-flex justify-content-center  '>
                  {e.active==1 ? 
     
     <center>
     <input type="checkbox" id="Tcinactiveswitch"
                  class="InActivecheckbox" onChange={handleInactive} />
      <label for="Tcinactiveswitch" className="toggleinactive">

   <p className='InActiveLable'>Active&nbsp; &nbsp;&nbsp;InActive</p>


      </label>
   
      </center>:
             
          <center>
          <input type="checkbox" id="Tcactiveswitch"
                       className="Activecheckbox"  onChange={handleactive}/>
           <label for="Tcactiveswitch" className="toggleactive">
                
    
        <p className='ActiveLable'>Active &nbsp;&nbsp;&nbsp;&nbsp;InActive</p>
    
    
           </label>
        
           </center>
}
              
                </div>
              </div>
              
       <div className=" modal-footer d-flex justify-content-center" >
              <button id ='Tc-buttonE'onClick={()=>UpdateTcUser(e.id,e.active)}>ok</button></div>
                
 </div>

 }
 )}
</form>
</div>
</div>
</div>
{pop? <div id="Loader">

<Oval
  height={40}
  width={50}
  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/> 
     
     </div>
 :null}

<div className="TCpopfade" id="modalDeleteForm" tabindex="-1" role="dialog">
{details.map((e)=>
{
return<div>
  <div className="modal-dialog" role="document">
    <div className="modal-contentA">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">Alert</h4>
        <button type="button" className="close" onClick={closedelForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>
   <div className="modal-body mx-3">

        <div className="md-form mb-3">
            <div className='text-center'>
          <h5>Are you sure want to&nbsp;<span style={{color:"red"}}>Delete?</span></h5>
          <h5 style={{color:"rgb(40, 166, 212)"}}>{e.userName}</h5>
          </div>
        </div>
   </div>

      <div className="modal-footer d-flex justify-content-center">
       <button className='TC-logout-button'onClick={()=>DeleteStatus(e.id,e.userName)}  type='submit'>Confirm</button>
        &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;<button className='TC-logout-button' onClick={Cancel} type='submit'>Cancel</button>
      </div>
      </form>
      
    </div>
  </div>
  </div>
  }
 )}
     </div>
    
</div>

 

    </>
  )
}

export default TCaddusermain
